import axios, { AxiosResponse } from "axios"

import APIServiceImpl from '../APIService/APIServiceImpl'
import FunnelServiceV1 from './FunnelServiceV1'
import { FunnelConfigResponseDTO } from "../../../../../requests-module"
import { defaultFunnelManager } from "../../../config/defaultFunnelManager"

// TEMPORARY returning a fixed config until we have a funnel manager working
// const mock = [{"familyId":"27","embededFamilies":[],"expanded":false},{"familyId":"3","embededFamilies":[],"expanded":false},{"familyId":"14","embededFamilies":["30"],"expanded":false},{"familyId":"53","embededFamilies":["30"],"expanded":false},{"familyId":"54","embededFamilies":["30"],"expanded":false},{"familyId":"55","embededFamilies":["30"],"expanded":false},{"familyId":"56","embededFamilies":["30"],"expanded":false},{"familyId":"57","embededFamilies":["30"],"expanded":false},{"familyId":"63","embededFamilies":["30"],"expanded":false},{"familyId":"8","embededFamilies":[],"expanded":false},{"familyId":"12","embededFamilies":[],"expanded":false},{"familyId":"4","embededFamilies":[],"expanded":false},{"familyId":"5","embededFamilies":[],"expanded":false},{"familyId":"11","embededFamilies":[],"expanded":false},{"familyId":"13","embededFamilies":[],"expanded":false},{"familyId":"40","embededFamilies":[],"expanded":false},{"familyId":"69","embededFamilies":[],"expanded":false},{"familyId":"78","embededFamilies":[],"expanded":false},{"familyId":"77","embededFamilies":[],"expanded":false}]

export default class FunnelServiceV1Impl
    extends APIServiceImpl
    implements FunnelServiceV1 {
    constructor() {
        const serviceUrl = window.env.VUE_APP_FUNNEL_MANAGER_URL || 'https://api-migdal.travelfactory.fr/cms/funnel-manager'
        super(serviceUrl)
    }

    async getFunnelConfig(packCode?: string, locale?: string): Promise<FunnelConfigResponseDTO> {
        try {
            const headers = {
                ...this.getDefaultHeaders(),
            }
            const localeRaw = locale || this.getLocale()
            const normalizedLocale = localeRaw === 'en-GB' ? 'en-US' : localeRaw.replaceAll('_', '-')
            const effectivePackCode = packCode || this.getPackCode()
            const url = `${this.getServiceUrl()}/${effectivePackCode}/${normalizedLocale}`
            const response: AxiosResponse<FunnelConfigResponseDTO> = await axios.get(url, {
                headers,
            })
            return response.data;
        } catch (error) {
            // Endpoint fails
            return defaultFunnelManager;
        }
    }

}
